"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var unsafeCharRegex = /[^0-9a-zA-Z\f\n\r\t\v\$\(\)\*\+\.\?\\\^\{\}\[\]\u0022 !#%&'-/@_`:~\u2019\u2013]/;
var _default = unsafeCharRegex;
exports["default"] = _default;
//# sourceMappingURL=unsafeCharRegex.js.map